import {z} from 'zod';
import {GenericTaskSchema, TaskType} from '../../task';
import {ApiDefinition} from '../definitions';
import {ObjectIdSchema} from '../../zod';

const GetTaskResponseSchema = GenericTaskSchema.pick({
  state: true,
  detailedState: true,
})
  .extend({
    id: ObjectIdSchema,
  })
  .nullable();
export type GetTaskResponse = z.infer<typeof GetTaskResponseSchema>;

export const GetTask = {
  path: 'task',
  method: 'get',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    type: z.enum([
      'fileCRMImport',
      'generateAnalystAgent',
      'generateSegmentationAgent',
      'hubSpotFullRun',
      'salesforceFullRun',
    ] as const satisfies TaskType[]),
  }),
  responseDataSchema: GetTaskResponseSchema,
} satisfies ApiDefinition;
